import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector, getUserIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IAttachment, IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { CameraAttachmentsConstants } from '../store/cameraAttachments.constants'
import { ICameraAttachmentsState } from '../store/cameraAttachments.types'
import { getCameraAttachmentsSelector } from '../selectors'
import Logger from '../../../services/logger.service'
import { getDateTime } from '../../../utilities'
import { getAttachments } from '../../signatures/store/signatures.actions'
import { v4 as uuidv4 } from 'uuid'
import { resetCameraAttachmentsState, setDisableCameraButton } from '../store/cameraAttachments.actions'
import { getMaximumCameraAttachments } from '../store/cameraAttachments.reducer'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveImage() {
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }

  try {
    const cameraAttachmentsState: ICameraAttachmentsState = yield select(getCameraAttachmentsSelector)
    const { image, name, category } = cameraAttachmentsState
    const serviceId: string = yield select(getServiceIdSelector)
    const userId: string = yield select(getUserIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)

    if (!image?.base64String) {
      return
    }

    let index = 0
    pcrDoc._fileAttachments?.forEach((attachment) => {
      if (attachment.index && attachment.index > index) index = attachment.index
    })
    index += 1

    const imageName = name ? `${name}.${image.format}` : `Photo${index}.${image.format}`

    Logger.info(
      `Attempting to attached image ${imageName} to PCR: ${pcrId} saved by user: ${userId} in service: ${serviceId}`
    )

    const attachment: IAttachment = {
      index: name ? undefined : index,
      fileExtension: image.format,
      data: image.base64String,
      category: category,
      name: imageName,
      uploadedDt: getDateTime(),
      id: uuidv4(),
    }

    const updatedFileAttachments = [...(pcrDoc._fileAttachments || []), attachment]
    if (updatedFileAttachments.length < getMaximumCameraAttachments()) {
      yield put(setDisableCameraButton(false))
    }
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      _fileAttachments: updatedFileAttachments,
    }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)

    Logger.info(
      `Successfully attached image ${imageName} to PCR: ${pcrId} saved by user: ${userId} in service: ${serviceId}`
    )

    yield put(resetCameraAttachmentsState())

    yield put(getAttachments())
  } catch (e) {
    yield put(throwPcrException(e))
  }
}

export function* saveImageSaga() {
  yield takeLatest([CameraAttachmentsConstants.SAVE_IMAGE], performWithMutexHOG, saveImage)
}
